var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _c(
            "div",
            { ref: "extratoSentenca", staticClass: "container" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.model,
                    "label-position": "top",
                    "label-width": "12em"
                  }
                },
                [
                  _c("vue-form-generator", {
                    ref: "form",
                    attrs: {
                      schema: _vm.schema,
                      model: _vm.model,
                      options: _vm.formOptions
                    },
                    on: { "model-updated": _vm.onModelUpdated }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0088a320", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0088a320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppEmissaoExtratoSentenca.vue
// module id = null
// module chunks = 